<div class="main nop-content">
  <div class="container">
    <mat-tab-group mat-align-tabs="center" animationDuration="0ms" class="push-down">
      <mat-tab *ngFor="let section of faqs?.sections">
        <ng-template mat-tab-label>
          <mat-icon *ngIf="section?.icon">{{section?.icon}}</mat-icon>
          <span class="faq-heading">{{section?.title}}</span>
        </ng-template>
        <mat-accordion>
          <mat-expansion-panel *ngFor="let question of section?.questions">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{question?.question}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div [innerHtml]="question?.answer | safeHtml"></div>
          </mat-expansion-panel>
        </mat-accordion>
      </mat-tab>
    </mat-tab-group>
  </div>
